import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import '../styles/trial-banner.css';

const UpgradeModal = ({ onClose }) => (
  <div className="upgrade-overlay" onClick={onClose}>
    <div className="upgrade-modal" onClick={(e) => e.stopPropagation()}>
      <span className="upgrade-modal-icon"></span>
      <h3>Upgrade Your Account</h3>
      <p>
        Your free trial gives you full access for 2 weeks. Upgrade to a full account
        and keep everything — no interruptions, no data loss.
      </p>
      <div className="upgrade-modal-actions">
        <a
          href="mailto:hello@stimulicentral.com?subject=Upgrade%20My%20Account"
          className="upgrade-contact-btn"
          onClick={onClose}
        >
          Contact Us to Upgrade
        </a>
        <button className="upgrade-dismiss-btn" onClick={onClose}>
          Maybe Later
        </button>
      </div>
    </div>
  </div>
);

// Trial expiration lockout disabled for now — see ProtectedRoute.js. Flip to re-enable this banner.
const TRIAL_BANNER_ENABLED = false;

export const TrialBanner = () => {
  const { userData } = useAuth();
  const [msLeft, setMsLeft] = useState(null);
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (!TRIAL_BANNER_ENABLED) return;
    if (userData?.accountType !== 'trial' || !userData?.trialExpiresAt) return;

    const getMs = () => {
      const exp = userData.trialExpiresAt?.toDate?.() ?? new Date(userData.trialExpiresAt);
      return Math.max(0, exp - Date.now());
    };

    setMsLeft(getMs());
    const id = setInterval(() => setMsLeft(getMs()), 60_000);
    return () => clearInterval(id);
  }, [userData]);

  if (!TRIAL_BANNER_ENABLED || userData?.accountType !== 'trial' || msLeft === null) return null;

  const days    = Math.floor(msLeft / 86_400_000);
  const hours   = Math.floor((msLeft % 86_400_000) / 3_600_000);
  const minutes = Math.floor((msLeft % 3_600_000) / 60_000);
  const isUrgent = msLeft < 86_400_000;

  const timeLabel = days > 0
    ? `${days}d ${hours}h remaining`
    : hours > 0
    ? `${hours}h ${minutes}m remaining`
    : `${minutes}m remaining`;

  return (
    <>
      <div
        className={`trial-banner${isUrgent ? ' urgent' : ''}`}
        onClick={() => setShowModal(true)}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => e.key === 'Enter' && setShowModal(true)}
      >
        <span className="trial-banner-text">⏱ Trial: {timeLabel}</span>
        <span className="trial-banner-cta">Upgrade for full access →</span>
      </div>
      {showModal && <UpgradeModal onClose={() => setShowModal(false)} />}
    </>
  );
};
